import { render } from "./Prijava.vue?vue&type=template&id=89546812"
import script from "./Prijava.vue?vue&type=script&lang=js"
export * from "./Prijava.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__